import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  GoogleAuthProvider,
  OAuthProvider
} from "firebase/auth";


import { auth, db } from "../../firebaseConfig";
import "../../styles/auth.css";
import { useLanguage } from "../../i18n/LanguageContext"; // ✅ ajusta si tu ruta es diferente
import { doc, serverTimestamp, setDoc } from "firebase/firestore";


export default function Login() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const mapAuthError = (err) => {
    const code = err?.code || "";

    // Comunes
    if (code === "auth/invalid-credential") return t("auth.errors.invalidCredential");
    if (code === "auth/user-not-found") return t("auth.errors.userNotFound");
    if (code === "auth/wrong-password") return t("auth.errors.wrongPassword");
    if (code === "auth/too-many-requests") return t("auth.errors.tooManyRequests");
    if (code === "auth/popup-closed-by-user") return t("auth.errors.popupClosed");
    if (code === "auth/cancelled-popup-request") return t("auth.errors.popupCancelled");
    if (code === "auth/popup-blocked") return t("auth.errors.popupBlocked");
    if (code === "auth/account-exists-with-different-credential") return t("auth.errors.diffCredential");
    if (code === "auth/operation-not-allowed") return t("auth.errors.notEnabled");
    if (code === "auth/network-request-failed") return t("auth.errors.network");

    return t("auth.errors.generic");
  };

  //const goPanel = () => navigate("/panel", { replace: true });
  const goPanel = () => navigate("/app", { replace: true });


  const onLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), pass);

      if (window.fbq) {
        window.fbq("track", "CompleteRegistration", {
          method: "email", // o "google"/"apple"
        });
      }

      goPanel();
    } catch (err) {
      console.error("Email login error:", err);
      setError(mapAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError("");
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });

      const result = await signInWithPopup(auth, provider);

      if (window.fbq) {
        window.fbq("track", "CompleteRegistration", {
          method: "google", // o "google"/"apple"
        });
      }

      await upsertUsuario({ user: result.user });
      

      goPanel();
    } catch (err) {
      console.error("Google login error:", err);
      setError(mapAuthError(err));
    } finally {
      setLoading(false);
    }
  };



 const upsertUsuario = async ({ user, fullName }) => {
    if (!user?.uid) return;

    // Apple: fullName solo llega la primera vez
    const nombreApple =
      fullName?.givenName || fullName?.familyName
        ? `${fullName?.givenName || ""} ${fullName?.familyName || ""}`.trim()
        : "";

    const userData = {
      id: user.uid,
      nombre: (nombreApple || user.displayName || "").trim(),
      correo: (user.email || "").trim(),
      fotoPerfil: (user.photoURL || "").trim(),
      createdAt: serverTimestamp(),
      fechaRegistro: serverTimestamp(), // con merge sirve como "createdAt" si no existe
    };

    const ref = doc(db, "usuarios", user.uid);
    await setDoc(ref, userData, { merge: true });
  };


  const handleAppleLogin = async () => {
    setError("");
    setLoading(true);
    try {
      const provider = new OAuthProvider("apple.com");
      provider.addScope("email");
      provider.addScope("name");

    if (window.fbq) {
      window.fbq("track", "CompleteRegistration", {
        method: "apple", // o "google"/"apple"
      });
    }

      await signInWithRedirect(auth, provider); // ✅ en vez de popup

       


  //    const result = await signInWithPopup(auth, provider);

      // Apple a veces manda fullName solo la primera vez
//      const fullName = result?._tokenResponse?.fullName;

  //    await upsertUsuario({ user: result.user, fullName });

    //  goPanel();
    } catch (err) {
      console.error("Apple login error:", err);
      setError(mapAuthError(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await getRedirectResult(auth);
        if (res?.user) {
          // ya inició sesión
          goPanel();
        }
      } catch (err) {
        console.error("Redirect result error:", err);
        setError(mapAuthError(err));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <div className="authWrap">
      <div className="authCard">
        <div className="brandRow">
          <div className="brandLogo">
            <img src="logo_512.png" alt="Logo" />
          </div>
          <div>
            <h1 className="brandTitle">{t("auth.login.brand")}</h1>
            <p className="brandSub">{t("auth.login.subtitle")}</p>
          </div>
        </div>

        <form onSubmit={onLogin}>
          <div className="field">
            <label className="label">{t("auth.login.emailLabel")}</label>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t("auth.login.emailPlaceholder")}
              required
              autoComplete="email"
            />
          </div>

          <div className="field">
            <label className="label">{t("auth.login.passLabel")}</label>
            <input
              className="input"
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              placeholder={t("auth.login.passPlaceholder")}
              required
              autoComplete="current-password"
            />
          </div>

          <div className="rowBetween">
            <Link className="linkBtn" to="/forgot">
              {t("auth.login.forgot")}
            </Link>
            <Link className="linkBtn" to="/signup">
              {t("auth.login.signup")}
            </Link>
          </div>

          {error ? <div className="errorBox">{error}</div> : null}

          <button className="primaryBtn" disabled={loading}>
            {loading ? t("auth.login.loading") : t("auth.login.submit")}
          </button>

          <div className="divider" />

          <div className="social-divider">
            <span>{t("auth.login.orContinue")}</span>
          </div>

          <button
            type="button"
            className="social-btn google"
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            <span className="social-icon">G</span>
            {t("auth.login.google")}
          </button>

          <button
            type="button"
            className="social-btn apple"
            onClick={handleAppleLogin}
            disabled={loading}
          >
            <span className="social-icon"></span>
            {t("auth.login.apple")}
          </button>

          <p className="bottomText">{t("auth.login.bottomNote")}</p>
        </form>
      </div>
    </div>
  );
}
